import { useEffect } from "react";

const ResetPasswordRedirect = () => {
  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");

    if (token) {
      // Match your React Native deep link configuration
      const appLink = `freshsweeper://reset-password/${token}`; // Path parameter
      const webFallback = `https://www.freshsweeper.com/reset-password/${token}`; // Consistent format

      // Try opening the app
      window.location.href = appLink;

      // If the app is not installed, redirect to web after a delay
      setTimeout(() => {
        window.location.href = webFallback;
      }, 1000); // Reduced to 1 second for better UX
    } else {
      // Handle missing token
      window.location.href = "https://www.freshsweeper.com/error";
    }
  }, []);

  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h1>Redirecting to FreshSweeper...</h1>
      <p>If you're not redirected automatically, <a href={`https://www.freshsweeper.com/reset-password/${new URLSearchParams(window.location.search).get("token")}`}>click here</a>.</p>
    </div>
  );
};

export default ResetPasswordRedirect;